export const LEGAL_DOCS = {
  terms: {
    overline: "TORQ CIRCUIT — LEGAL",
    title: "EVENT TERMS & CONDITIONS",
    meta: "VERSION v1 — READ TOGETHER WITH THE TICKET PROTECTION & REFUND POLICY, PRIVACY POLICY AND ANY EVENT-SPECIFIC RULES",
    intro: [],
    sections: [
      {
        h: "About These Terms",
        paras: [
          "These Terms & Conditions govern registration, participation and attendance at events organised under the TORQ CIRCUIT brand (“Event”).",
          "By registering for, purchasing a ticket to, or participating in an Event, you agree to these Terms, the applicable event rules and the policies displayed during registration.",
        ],
      },
      {
        h: "Event Organizer",
        paras: [
          "TORQ CIRCUIT is the event brand under which fitness, running and related sporting events may be organized.",
          "The legal name, registered address and contact details of the entity or person responsible for each Event will be disclosed on the website, registration page or applicable event communication.",
          "References to the “Organizer” mean the legal person or entity responsible for the relevant Event. The brand name alone does not establish a separate legal entity.",
        ],
      },
      {
        h: "Registration and Eligibility",
        paras: [
          "Participants must provide accurate registration information, complete payment and comply with the age, eligibility and participation requirements specified for the Event.",
          "The Organizer may refuse or cancel a registration where information is materially false, eligibility requirements are not met, payment is unsuccessful or participation would present a legitimate safety concern, subject to applicable law.",
          "Tickets are valid only for the registered participant unless a transfer is expressly permitted under the applicable ticket terms.",
        ],
      },
      {
        h: "Participant Health and Safety",
        paras: [
          "Running, obstacle courses, functional fitness challenges and other sporting activities involve inherent risks, including falls, collisions, muscle injuries, dehydration, heat-related illness and other physical injuries.",
          "Participants are responsible for assessing their fitness for the activity, following event instructions and informing the appropriate event personnel of any condition that may affect safe participation.",
          "Participants must follow safety instructions, use equipment as directed and stop participating if they experience concerning symptoms or are instructed to stop by authorised event personnel.",
          "The Organizer will take reasonable safety measures appropriate to the Event and applicable legal requirements. Nothing in these Terms excludes liability that cannot lawfully be excluded, including liability arising from negligence where applicable.",
        ],
      },
      {
        h: "Medical Emergencies",
        paras: [
          "Participants consent to reasonable emergency assistance being sought if an incident occurs during an Event.",
          "Where reasonably necessary, the Organizer may contact emergency services or provide available first-aid assistance. Any further medical treatment remains subject to applicable law, medical judgment and the circumstances.",
          "Participants are responsible for their own medical expenses except where the Organizer is legally responsible or another applicable arrangement provides otherwise.",
        ],
      },
      {
        h: "Event Changes, Postponement and Cancellation",
        paras: [
          "The Organizer may change an Event's schedule, route, venue, format or activities where reasonably necessary due to safety concerns, weather, government directions, venue restrictions, operational requirements or circumstances beyond reasonable control.",
          "If an Event is postponed, rescheduled or cancelled, participants will be informed of the applicable arrangements and available options.",
          "Refunds, rescheduling options and other remedies will be provided in accordance with the published Ticket Protection & Refund Policy and applicable law.",
        ],
      },
      {
        h: "Ticket Protection, Cancellation and Refunds",
        paras: [
          "Registration fees, protection-plan benefits, participant changes, transfers and cancellation requests are governed by the separate Ticket Protection & Refund Policy published on the website or registration page.",
          "Any additional protection plan must be purchased on the terms disclosed at checkout.",
          "Nothing in these Terms removes any mandatory refund or consumer remedy required by applicable law.",
        ],
      },
      {
        h: "Participant Conduct",
        paras: [
          "Participants must behave respectfully toward other participants, spectators, staff, volunteers, venue personnel and event partners.",
          "Harassment, violence, abusive conduct, cheating, deliberate interference with equipment, unauthorised access to restricted areas or disregard for safety instructions may result in warnings, removal from an activity or disqualification where reasonably justified.",
          "Any action will be proportionate to the circumstances and consistent with applicable law. Refund eligibility will be determined under the published policy and applicable law.",
        ],
      },
      {
        h: "Assumption of Inherent Risks and Liability",
        paras: [
          "Participants acknowledge that sporting activities carry inherent risks, including risks that cannot be entirely eliminated despite reasonable precautions.",
          "To the extent permitted by applicable law, the Organizer is not responsible for losses arising solely from inherent sporting risks, a participant's failure to follow reasonable safety instructions, or the acts of unrelated third parties beyond the Organizer's reasonable control.",
          "Nothing in these Terms excludes or limits liability for fraud, wilful misconduct, negligence or other liability where exclusion or limitation is prohibited by law.",
          "No provision in these Terms waives a participant's mandatory statutory rights.",
        ],
      },
      {
        h: "Organizer's Team, Staff and Volunteers",
        paras: [
          "The Organizer's founders, directors, officers, employees, contractors and volunteers perform their respective duties in connection with the Event.",
          "To the extent permitted by applicable law, claims arising from an Event will be assessed according to the responsibility and conduct of the relevant parties. Nothing in these Terms grants blanket immunity to any individual or entity for their own unlawful conduct or liability that cannot legally be excluded.",
        ],
      },
      {
        h: "Third-Party Services and Venues",
        paras: [
          "An Event may involve venues, timing providers, ticketing platforms, equipment suppliers, medical providers, sponsors and other independent service providers.",
          "Their services may be subject to separate terms and conditions. The Organizer will exercise any responsibilities imposed on it by applicable law and does not disclaim its own legal obligations merely because a third party is involved.",
        ],
      },
      {
        h: "Photography, Video and Event Publicity",
        paras: [
          "Photography, video recording and livestreaming may take place at an Event for documentation, security or publicity.",
          "Where identifiable participant images or personal information are used for promotional purposes, the Organizer will obtain consent or rely on another lawful basis where applicable. Participants may contact the Organizer regarding privacy concerns or applicable rights.",
          "Separate consent will be obtained where required by law. Participation does not constitute an unlimited waiver of privacy or publicity rights.",
        ],
      },
      {
        h: "Personal Data and Privacy",
        paras: [
          "Personal information collected during registration may be used for registration management, event communication, eligibility verification, safety coordination, payment administration and other disclosed lawful purposes.",
          "Personal information will be handled in accordance with the website's Privacy Policy and applicable Indian data-protection law. Information will be shared with service providers or authorities where necessary and legally permitted.",
          "Participants may contact the Organizer through its published contact details to make a privacy-related request.",
        ],
      },
      {
        h: "Property, Equipment and Personal Belongings",
        paras: [
          "Participants are responsible for their personal belongings and must use event equipment according to instructions.",
          "The Organizer will not be responsible for loss, theft or damage except where it is legally responsible or applicable law requires otherwise.",
          "Participants must not damage venue property, equipment or another person's belongings.",
        ],
      },
      {
        h: "Minors and Guardian Consent",
        paras: [
          "Where minors are permitted to participate, registration and participation must comply with the Event's age requirements and applicable law.",
          "Parent or legal guardian consent and supervision will be obtained where required. A guardian's consent does not remove any legal duty owed to a minor.",
        ],
      },
      {
        h: "Indemnity",
        paras: [
          "To the extent permitted by applicable law, a participant may be responsible for direct losses or reasonable costs arising from the participant's unlawful conduct, deliberate property damage or material breach of these Terms.",
          "This clause does not require participants to indemnify the Organizer for the Organizer's own negligence, unlawful conduct or liabilities that cannot lawfully be transferred.",
        ],
      },
      {
        h: "Intellectual Property",
        paras: [
          "The TORQ CIRCUIT name, logo, event branding, original content and other protected materials may not be copied, reproduced, commercially exploited or used without the relevant rights holder's permission, except where permitted by law.",
        ],
      },
      {
        h: "Force Majeure",
        paras: [
          "The Organizer may modify, suspend, postpone or cancel an Event where circumstances beyond reasonable control make the Event unsafe, unlawful or impracticable, including severe weather, natural disasters, public emergencies, government restrictions or venue closure.",
          "The Organizer will communicate material changes as reasonably practicable and provide remedies required under applicable law.",
        ],
      },
      {
        h: "Complaints and Dispute Resolution",
        paras: [
          "Participants may submit complaints through the official contact details published on the website.",
          "These Terms are governed by the laws of India. Disputes will be dealt with by competent courts and authorities having jurisdiction under applicable law. Nothing in this section prevents a participant from exercising mandatory consumer rights or seeking relief before an authority legally empowered to hear the matter.",
        ],
      },
      {
        h: "Changes to These Terms",
        paras: [
          "The Organizer may update these Terms when necessary. The latest version and its effective date will be published on the website.",
          "Changes will not remove rights that have already accrued or override mandatory legal protections.",
        ],
      },
      {
        h: "Contact Information",
        paras: [
          "For registration, event, safety, refund or legal-policy queries, contact the Organizer using the official email address: info@torqcircuit.com, as published on the TORQ CIRCUIT website.",
        ],
      },
    ],
    outro: [
      "These Terms must be read together with the applicable Ticket Protection & Refund Policy, Privacy Policy and any event-specific rules.",
      "Nothing in these Terms excludes or limits any right or liability that cannot lawfully be excluded or limited under applicable law.",
    ],
  },

  refund: {
    overline: "TORQ CIRCUIT — LEGAL",
    title: "TICKET PROTECTION & REFUND POLICY",
    meta: "VERSION v1 — READ TOGETHER WITH THE EVENT TERMS & CONDITIONS",
    intro: [],
    sections: [
      {
        h: "Standard Registration",
        bullets: [
          "All registrations are final and non-refundable for participant-initiated cancellations, subject to applicable law.",
          "Registrations cannot be transferred or exchanged for another event.",
          "Failure to attend does not qualify for a refund.",
        ],
      },
      {
        h: "Lite Flex — ₹199",
        bullets: [
          "One participant name change is permitted up to 7 days before the event.",
          "No refund for voluntary cancellation or non-attendance.",
          "No transfer to another event.",
        ],
      },
      {
        h: "Full Flex — ₹349",
        bullets: [
          "One participant name change is permitted up to 72 hours before the event.",
          "One transfer of the registration to another eligible participant is permitted up to 72 hours before the event, subject to organizer approval and event eligibility rules.",
          "No refund for voluntary cancellation or non-attendance.",
          "No transfer of registration fees to another event.",
        ],
      },
      {
        h: "Event Cancellation or Postponement",
        paras: [
          "If the organizer cancels or postpones an event, participants will be informed of the available options and applicable timelines. Any refund or alternative remedy required under applicable law will be honoured.",
        ],
      },
      {
        h: "Force Majeure and Safety",
        paras: [
          "The organizer may modify, postpone, suspend or cancel an event when required for participant safety, government directions, severe weather, venue restrictions or other circumstances beyond reasonable control. The organizer will communicate changes promptly and provide remedies in accordance with applicable law.",
        ],
      },
      {
        h: "Acknowledgement",
        paras: [
          "By completing registration, participants confirm that they have read and accepted the ticket protection, cancellation and event-change terms displayed before payment.",
          "These terms do not limit any mandatory rights available to consumers under applicable law.",
        ],
      },
    ],
    outro: [
      "To request a name change or transfer under a Flex plan, write to info@torqcircuit.com with your booking reference before the applicable deadline.",
    ],
  },

  privacy: {
    overline: "TORQ CIRCUIT — LEGAL",
    title: "PRIVACY POLICY",
    meta: "VERSION v1 — ALIGNED WITH THE DIGITAL PERSONAL DATA PROTECTION ACT, 2023 (INDIA)",
    intro: [
      "This Privacy Policy explains how the organizer of TORQ CIRCUIT events (“Organizer”, “we”, “us”) collects, uses, stores and protects personal information submitted through this website, the registration flow and related event communications.",
      "By registering for an event or using this website, you consent to the practices described in this policy.",
    ],
    sections: [
      {
        h: "Information We Collect",
        bullets: [
          "Identity details: full name, date of birth, gender and, for Doubles entries, your partner's details and team name.",
          "Contact details: email address and mobile number.",
          "Safety details: emergency contact name and phone number.",
          "Booking data: category, ticket protection plan, promo codes, payment status and transaction references.",
          "Technical data: basic device, browser and usage information needed to operate and secure the website.",
        ],
        paras: [
          "Payments are processed by PayU. We never see, store or have access to your full card number, UPI PIN, net-banking credentials or OTPs.",
        ],
      },
      {
        h: "How We Use Your Information",
        bullets: [
          "Processing and managing your registration and payment.",
          "Verifying your identity and email address (OTP verification).",
          "Issuing tickets, QR codes and race-day check-in.",
          "Event communication: confirmations, schedules, changes and safety briefings.",
          "Safety coordination, including contacting your emergency contact if required.",
          "Meeting legal, tax, accounting and regulatory obligations.",
          "Sending training tips and future event news only where you have opted in.",
        ],
      },
      {
        h: "Legal Basis and Consent",
        paras: [
          "We process personal data with your consent and as necessary to deliver the event you registered for, in accordance with the Digital Personal Data Protection Act, 2023 and other applicable Indian law.",
          "You may withdraw consent for optional communications at any time by writing to us; this does not affect processing required to deliver your registration or required by law.",
        ],
      },
      {
        h: "Who We Share It With",
        bullets: [
          "Payment processing: PayU (and its banking partners) to complete your transaction.",
          "Transactional email delivery: our email service provider, to send OTPs, confirmations and event updates.",
          "Event operations: venue, timing, medical and security partners, only to the extent needed to run a safe event.",
          "Authorities, courts or regulators where disclosure is required by law.",
        ],
        paras: ["We do not sell your personal information to anyone."],
      },
      {
        h: "Data Retention",
        paras: [
          "Registration and payment records are retained for as long as needed to run the event and to meet legal, tax and accounting requirements under Indian law, after which they are securely deleted or anonymised.",
        ],
      },
      {
        h: "Data Security",
        paras: [
          "We apply reasonable technical and organisational safeguards, including access controls, hashed one-time codes, server-side payment verification and restricted admin access.",
          "No method of transmission over the internet is completely secure; if you suspect misuse of your information, contact us immediately.",
        ],
      },
      {
        h: "Your Rights",
        paras: [
          "Under applicable Indian data-protection law you may request access to your personal data, correction of inaccurate data, erasure where legally permissible, and redressal of grievances.",
          "To exercise any of these rights, email info@torqcircuit.com from your registered email address with your booking reference. We will respond within a reasonable time as required by law.",
        ],
      },
      {
        h: "Cookies and Analytics",
        paras: [
          "This website uses minimal technical storage required for core functionality and security. We do not run third-party advertising trackers.",
        ],
      },
      {
        h: "Minors",
        paras: [
          "Where minors are permitted to participate, registration must be completed with parent or legal guardian consent as described in the Event Terms & Conditions.",
        ],
      },
      {
        h: "Changes to This Policy",
        paras: [
          "We may update this policy when necessary. The latest version will be published on this page and will not remove rights that have already accrued or override mandatory legal protections.",
        ],
      },
      {
        h: "Grievance Officer and Contact",
        paras: [
          "For any privacy question, request or grievance, contact the Organizer at info@torqcircuit.com. Your query will be handled in accordance with applicable Indian data-protection law.",
        ],
      },
    ],
    outro: [
      "This policy must be read together with the Event Terms & Conditions and the Ticket Protection & Refund Policy.",
    ],
  },
};
